import { Injectable } from '@angular/core';
import {
  RETURNSTOCKCART,
  AdpCustomer,
  attributesMap,
  attributesPropertiesMap,
  RECEIVESTOCKLOCATION, REFERENCE
} from '../providers/data';
import {IMAGES_BASE_URL} from './config';

import { Storage } from '@ionic/storage';


import {DomSanitizer} from '@angular/platform-browser';
@Injectable()
export class ReturncartManager {



  public getCust:any ;
  constructor(private storage:Storage){

  }


  clearCart(){
    RETURNSTOCKCART.items = [];
  }

  getItems(){
    return RETURNSTOCKCART.items;
  }


  addToCartNew(product) {
    if(!Number(product.quantity)){
      // if(Number(product.quantity)<=1){
      product.quantity = 0;
      // }
    }

    RETURNSTOCKCART.items.push(product);
    // this.persistOrderLocal();

// }
  }
  addProductToCart(product) {
    var index= RETURNSTOCKCART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
      RETURNSTOCKCART.items[index].quantity++;
      // this.persistOrderLocal();
    } else {
      if (Number(product.quantity) != 0) {
        product.quantity = Number(product.quantity);
      } else {
        product.quantity = 0;
      }
      this.addToCartNew(product);
    }
    //alert(JSON.stringify(STOCKCART));
  }



  // Remove Item
  removeNew(index: number): void {

    RETURNSTOCKCART.items.splice(index, 1);
    // this.persistOrderLocal();
  }

  deleteProductFromCart(product){
    var index= RETURNSTOCKCART.items.map(function(x) {return x.id; }).indexOf(product.id);
    if (index != -1) {
      this.removeNew(index);
    }
  }

  genrateOrder(status){
    //alert(JSON.stringify(STOCKCART));
    let total = 0;
    let orderProducts = [];
    let expectedShipmentDate = RETURNSTOCKCART.shipDate;
    for(let item of RETURNSTOCKCART.items){

      // if(this.discountCheck(item.discountPrice)){
      //   total =  total + (Number(item.discountPrice) * Number(item.quantity));
      // }else{
      //   total =  total + (Number(item.price) * Number(item.quantity));
      // }

      var orderDetailDTOs: any = {

        "productsDTO":item,
        "quantity": item.quantity,
        "expectedShipmentDate": expectedShipmentDate,
        "attributeSearch":item.attributeSearch
      };

      orderProducts.push(orderDetailDTOs);
    }

    if(RETURNSTOCKCART.customer.locationsDTOs.length>0){
      for(let locationId in RETURNSTOCKCART.customer.locationsDTO){
        RETURNSTOCKCART.customer.locationsDTO[locationId].createdAt = "";
        RETURNSTOCKCART.customer.locationsDTO[locationId].updatedAt = "";
      }
    }

    RETURNSTOCKCART.customer.customerJson = "";

    let order = {
      "id":RETURNSTOCKCART.orderId,
      // "orderTitle": this.getOrderTitle(),
      "salesManId":RETURNSTOCKCART.user.id,
      "orderMessage":RETURNSTOCKCART.orderMessage,
      "expectedShipmentDate": RETURNSTOCKCART.expectedShipmentDate,
      "totalAmount":""+total.toFixed(2),
      "totalTexAmount":"10",
      "orderStatus":status,
      "customerDTO":RETURNSTOCKCART.customer,
      "orderDetailDTOs": orderProducts,
      "shippingServiceName":RETURNSTOCKCART.shippingServiceName,
      "shippingServiceValue":RETURNSTOCKCART.shippingServiceId
    };
    return order;

  }

  // receiveStock(status, reference, productLocation){
  //   //alert(JSON.stringify(STOCKCART));
  //   let total = 0;
  //   let orderProducts = [];
  //   let expectedShipmentDate = STOCKCART.shipDate;
  //   for(let item of STOCKCART.items){
  //
  //     console.log("BBBBBBBBBBBBBBBBBBBBBBB " + item.badProductDtoList);
  //     if(item.badProductDtoList !== undefined){
  //       let total = 0;
  //       for(let badPro of item.badProductDtoList){
  //         total += badPro.quantity;
  //       }
  //       item.quantity = item.quantity-total;
  //     }
  //
  //
  //     if(this.discountCheck(item.discountPrice)){
  //       total =  total + (Number(item.discountPrice) * Number(item.quantity));
  //     }else{
  //       total =  total + (Number(item.price) * Number(item.quantity));
  //     }
  //
  //     item.quantity = item.quantity;
  //
  //     item.referenceNumber = reference;
  //     item.locationCode = productLocation;
  //
  //
  //     var orderDetailDTOs: any = {
  //
  //       "productsDTO":item,
  //       "quantity": item.quantity,
  //       "expectedShipmentDate": expectedShipmentDate,
  //       "attributeSearch":item.attributeSearch,
  //     };
  //     orderProducts.push(orderDetailDTOs);
  //   }
  //   STOCKCART.customer.customerJson = "";
  //
  //
  //   let order = {
  //     "id":STOCKCART.orderId,
  //     "barCode":STOCKCART.orderId,
  //     "orderTitle": this.getOrderTitle(),
  //     "salesManId":STOCKCART.user.id,
  //     "orderMessage":STOCKCART.orderMessage,
  //     "expectedShipmentDate": STOCKCART.expectedShipmentDate,
  //     "totalAmount":""+total.toFixed(2),
  //     "totalTexAmount":"10",
  //     "orderStatus":status,
  //     "customerDTO":STOCKCART.customer,
  //     "orderDetailDTOs": orderProducts,
  //     "shippingServiceName":STOCKCART.shippingServiceName,
  //     "shippingServiceValue":STOCKCART.shippingServiceId
  //   };
  //
  //   return order;
  //
  // }

  clearCartProducts(){
    for(let product of RETURNSTOCKCART.items){
    }
    RETURNSTOCKCART.items = [];
  }

  getProductsCount(){
    return RETURNSTOCKCART.items.length;
  }



  // persistOrderLocal(){
  //   // TODO: Store the list of Cart against their user/sales persons
  //   let itemQuantityStatus = false;
  //   for(let product of RETURNSTOCKCART.items){
  //     if(product.quantity > 0){
  //       itemQuantityStatus = true;
  //       break;
  //     }
  //   }
  //
  //   if(Number(RETURNSTOCKCART.items.length) > 0 && itemQuantityStatus){
  //     this.storage.set(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId(),STOCKCART);
  //
  //   }else{
  //     this.unPersistOrderLocal();
  //   }
//this.gVLogger.log(STOCKCART);
//   }
//   unPersistOrderLocal(){
//     this.storage.remove(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId());
//
//
//   }

// getPersistedOrderLocal(){
//
//   return this.storage.get(this.getADPCustomerUUID()+"-cart-"+this.getSalesManId());
// }

// setCartFull(cartTemp){
//    STOCKCART.items = cartTemp.items;
//    STOCKCART.orderId = cartTemp.orderId;
//    STOCKCART.orderMessage = cartTemp.orderMessage;
//    STOCKCART.customer = cartTemp.customer;
//    STOCKCART.orderTitle = cartTemp.orderTitle;
//   // this.gVLogger.log("Cart Replaced...",cartTemp);
// }


}



// WEBPACK FOOTER //
// ./src/providers/returncart-manager.ts